<template>
	<div class="">
		<img :src="$route.query.statement" style="width: 100%;" alt="" />
	</div>
</template>

<script>
	export default {
		data(){
			return{
				zhongyuhaole:""
			}
		},
		
	}
	
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/view/tupian.vue